import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupByEventName',
})
export class GroupByEventName implements PipeTransform {
  transform(value, args: string[]): any {
    const groups = {};

    if (!value) {
      return [];
    }

    value.forEach(o => {
      const groupName = o.EventName.replace(/\s+/g, '');

      groups[groupName] = groups[groupName]
        ? groups[groupName]
        : {
            EventName: o.EventName,
            HomeTeam: o.HomeTeam,
            AwayTeam: o.AwayTeam,
            Enable: o.Enable,
            OddId1: o.OddId1,
            Banko: o.Banko,
            MatchId: o.MatchId,
            EventDate: o.EventDate,
            EventDateLong: o.EventDateLong,
            OddsType: o?.OddsType,
            SpecialBetValue: o?.SpecialBetValue,
            Outcomes: o?.Outcomes,
            HomeTeamId: o.HomeTeamId,
            AwayTeamId: o.AwayTeamId,
            OddValue: o.OddValue,
            eEvents: [],
          };
      groups[groupName].eEvents.push(o);

      try {
        groups[groupName].eEvents =
          groups[groupName].eEvents.length > 1
            ? groups[groupName].eEvents.sort((a, b) => {
                return a.OddId1 - b.OddId1;
              })
            : groups[groupName].eEvents;
      } catch (e) {
        console.warn('OddId1 is not found : groupByEventName');
      }
    });

    return Object.keys(groups)
      .map(function (key) {
        return groups[key];
      })
      .sort((a, b) => {
        return a.EventName > b.EventName ? 1 : -1;
      })
      .sort((a, b) => {
        return new Date(a.EventDateLong) > new Date(b.EventDateLong) ? 1 : -1;
      });
  }
}
